export default "<app-head-actions></app-head-actions>\r\n<router-outlet></router-outlet>\r\n"